import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { languageInterceptor } from '@core/interceptors/language-interceptor';
import { Nsad } from '@core/themes/nsad-preset';
import { getDefaultLang } from '@core/utils/lang-util';
import { errorInterceptor } from '@core/interceptors/error-interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { tokenInterceptor } from '@core/interceptors/token-interceptor';

import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import { DatePipe, registerLocaleData } from '@angular/common';
import { apiInterceptor } from '@core/interceptors/api-interceptor';
import { DialogService } from 'primeng/dynamicdialog';

registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');

export const appConfig: ApplicationConfig = {
  providers: [
    ConfirmationService,
    DialogService,
    DatePipe,
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        apiInterceptor,
        languageInterceptor,
        errorInterceptor,
        tokenInterceptor
      ])
    ),
    MessageService,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Nsad,
        options: {
          darkModeSelector: '.my-app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng'
          },
          // zIndex: {
          //   modal: 1100,    
          //   overlay: 1000,
          //   menu: 1000,
          //   tooltip: 1100
          // },
        }
      }
    }),

    provideTransloco({
      config: {
        availableLangs: ['en', 'es'],
        defaultLang: getDefaultLang(),
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    })
  ]
};
